import { FC } from 'react'

import MaskedInput, { MaskedInputProps } from 'react-text-mask'

import { mask } from './mask'

export const DobMaskedInput: FC<Omit<MaskedInputProps, 'mask'>> = (props) => (
  <MaskedInput mask={mask} placeholder="DD/MM/YYYY" {...props} />
)
